export const FETCH_COMBINED_VIEW_DATA_REQUEST="FETCH_COMBINED_VIEW_DATA_REQUEST";
export const FETCH_COMBINED_VIEW_DATA_SUCCESS="FETCH_COMBINED_VIEW_DATA_SUCCESS";

export const GET_COMBINED_VIEW_FILES_REQUEST="GET_COMBINED_VIEW_FILES_REQUEST";
export const GET_COMBINED_VIEW_FILES_SUCCESS="GET_COMBINED_VIEW_FILES_SUCCESS";

export const GET_COMBINED_VIEW_NOTES_REQUEST="GET_COMBINED_VIEW_NOTES_REQUEST";
export const GET_COMBINED_VIEW_NOTES_SUCCESS="GET_COMBINED_VIEW_NOTES_SUCESS";

export const GET_COMBINED_VIEW_PROFILES_REQUEST="GET_COMBINED_VIEW_PROFILES_REQUEST";
export const GET_COMBINED_VIEW_PROFILES_SUCCESS="GET_COMBINED_VIEW_PROFILES_SUCCESS";

export const GET_COMBINED_VIEW_ACTIVITY_SUCCESS="GET_COMBINED_VIEW_ACTIVITY_SUCCESS";
export const GET_COMBINED_VIEW_FILTER_SUCCESS="GET_COMBINED_VIEW_FILTER_SUCCESS";
export const GET_COMBINED_VIEW_SETTING_SUCCESS="GET_COMBINED_VIEW_SETTING_SUCCESS";
export const GET_COMBINE_VIEW_ALL_DATA_SUCCESS = "GET_COMBINE_VIEW_ALL_DATA_SUCCESS";
export const GET_COMBINED_VIEW_LOGS_REQUEST="GET_COMBINED_VIEW_LOGS_REQUEST";
export const GET_COMBINED_VIEW_LOGS_SUCCESS="GET_COMBINED_VIEW_LOGS_SUCCESS";

export const FETCH_COMBINED_VIEW_DATA_FROM_PDATA_REQUEST = "FETCH_COMBINED_VIEW_DATA_FROM_PDATA_REQUEST";
export const FETCH_COMBINED_VIEW_DATA_FROM_PDATA_SUCCESS = "FETCH_COMBINED_VIEW_DATA_FROM_PDATA_SUCCESS";
export const FETCH_COMBINED_VIEW_DATA_FROM_PDATA_ERROR = "FETCH_COMBINED_VIEW_DATA_FROM_PDATA_ERROR";

export const FETCH_COMBINE_VIEW_ACTIVITY_LOG_SUCCESS = "FETCH_COMBINE_VIEW_ACTIVITY_LOG_SUCCESS";
export  const  FETCH_COMBINE_VIEW_WORKKARD_LOG_SUCCESS = "FETCH_COMBINE_VIEW_WORKKARD_LOG_SUCCESS";

export  const  FETCH_COMBINE_VIEW_WORKKARD_SUCCESS = "FETCH_COMBINE_VIEW_WORKKARD_SUCCESS";
export const FETCH_COMBINE_VIEW_ACTIVITY_SUCCESS = "FETCH_COMBINE_VIEW_ACTIVITY_SUCCESS";

export const FETCH_COMBINE_VIEW_ACTIVITY_NOTE_SUCCESS = "FETCH_COMBINE_VIEW_ACTIVITY_NOTE_SUCCESS";

export  const FETCH_COMBINE_VIEW_ACTIVITY_ACTION_HISTORY_SUCCESS = "FETCH_COMBINE_VIEW_ACTIVITY_ACTION_HISTORY_SUCCESS";
export const FETCH_COMBINE_VIEW_WORKKARD_ACTION_HISTORY_SUCCESS = "FETCH_COMBINE_VIEW_WORKKARD_ACTION_HISTORY_SUCCESS";

export const SETTINGS_FILTER_REQUEST = "SETTINGS_FILTER_REQUEST";
export const SETTINGS_FILTER_SUCCESS = "SETTINGS_FILTER_SUCCESS";

export const USERS_FILTER_REQUEST= "USERS_FILTER_REQUEST";
export const USERS_FILTER__SUCCESS = "USERS_FILTER_SUCCESS";

export const ACTIVITY_TITLE_FILTER_REQUEST= "ACTIVITY_TITLE_FILTER_REQUEST";
export const ACTIVITY_TITLE_FILTER__SUCCESS = "ACTIVITY_TITLE_FILTER__SUCCESS";

export const DATE_FILTER_REQUEST= "DATE_FILTER_REQUEST";

export const RESET_COMBINED_VIEW_DATA = "RESET_COMBINED_VIEW_DATA";
export const RESET_ALL_COMBINED_VIEW_DATA="RESET_ALL_COMBINED_VIEW_DATA";

export const UPDATE_COMBINED_VIEW_DATA_REQUEST="UPDATE_COMBINED_VIEW_DATA_REQUEST";
export const UPDATE_COMBINED_VIEW_DATA_SUCCESS="UPDATE_COMBINED_VIEW_DATA_SUCCESS";

export const SORT_COMBINED_VIEW_DATA_REQUEST='SORT_COMBINED_VIEW_DATA_REQUEST';
export const SORT_COMBINED_VIEW_DATA_SUCCESS='SORT_COMBINED_VIEW_DATA_SUCCESS';

export const UPDATE_COMBINED_VIEW_FILE_CAPTION="UPDATE_COMBINED_VIEW_FILE_CAPTION";

export const REMOVE_PDATA = "REMOVE_PDATA";

export const FETCH_COMBINED_VIEW_WORKKARD_FILES_REQUEST = "FETCH_COMBINED_VIEW_WORKKARD_FILES_REQUEST";
export const FETCH_COMBINED_VIEW_WORKKARD_FILES_SUCCESS = "FETCH_COMBINED_VIEW_WORKKARD_FILES_SUCCESS";

export const DOWNLOAD_ALL_FILES = "DOWNLOAD_ALL_FILES";
export const SET_ALL_FILES_FOR_DOWNLOAD = "SET_ALL_FILES_FOR_DOWNLOAD";
export const SET_DOWNLOAD_CLICKED_STATE = "SET_DOWNLOAD_CLICKED_STATE";
export const SET_IS_VIEW_CHANGE = "SET_IS_VIEW_CHANGE";
export const RESET_ALL_DOWNLOAD_FILE_DATA = "RESET_ALL_DOWNLOAD_FILE_DATA";
export const FETCH_COMBINED_VIEW_FILES_SUCCESS = "FETCH_COMBINED_VIEW_FILES_SUCCESS";
export const UPDATE_COMBINED_VIEW_FILES_SUCCESS = "UPDATE_COMBINED_VIEW_FILES_SUCCESS";

export const FETCH_PRINT_COMBINED_VIEW_DATA_REQUEST="FETCH_PRINT_COMBINED_VIEW_DATA_REQUEST";
export const FETCH_PRINT_COMBINED_VIEW_DATA_SUCCESS="FETCH_PRINT_COMBINED_VIEW_DATA_SUCCESS";

export const RESET_PRINT_COMBINED_VIEW_DATA="RESET_PRINT_COMBINED_VIEW_DATA";
export const UPDATE_DESELECTED_NOTE_TEMPLATE_COMBINED_VIEW_DATA = "UPDATE_DESELECTED_NOTE_TEMPLATE_COMBINED_VIEW_DATA";
export const SAVE_DESELECTED_NOTE_TEMPLATE_COMBINED_VIEW_DATA = "SAVE_DESELECTED_NOTE_TEMPLATE_COMBINED_VIEW_DATA";